module.exports = __webpack_public_path__ + "img/mood-normal.5a229bb2.svg";